import { Link, ThemeProvider, Typography, createTheme } from "@mui/material"
import { WHITE_FFF } from "../styles/Colors"
import { Box } from "@mui/system";
import { priceStore } from "../zustand/priceStore";

function Header() {

    const pricesGeneratedAt = priceStore((state) => state.pricesGeneratedAt);
    const dateAndTimeArray = pricesGeneratedAt.split(" ");
    const utcTime = dateAndTimeArray[1];
    
    const UTCTimeDisplay =() => (
        <span>{utcTime}</span>
    );

    const DisclaimerLink = () => (
        <Link href="https://www.m-daq.com/disclaimer/" target="_blank" underline="always" textAlign="right" color={WHITE_FFF} fontSize="11px" fontFamily={"Avenir"}>
            disclaimer
        </Link>
    )

    const theme = createTheme({
        components: {
            MuiTypography: {
                styleOverrides: {
                    root: {
                        fontSize: '11px',
                    },
                },
            },
        },
    });

    const MidMarketRates = () => (
            <Box 
                sx={{
                    display: "flex",
                    paddingRight: '0.5',
                    justifyContent: 'flex-end'
                }}
                px={{ xs: 0.5, sm: 2, md: 2, lg: 0.5, xl: 0 }}
            >
                <ThemeProvider theme={theme}>
                    <Typography sx={{ textAlign: 'justify', fontSize: "11px",
                        fontFamily: 'Avenir',
                        color: WHITE_FFF, variant: 'body1'}}>
                        Indicative mid-market rates last updated at <UTCTimeDisplay /> UTC, see <DisclaimerLink /> for more information. For restricted markets, last updates outside of market trading hours are onshore market closing rates.
                    </Typography>
                </ThemeProvider>
            </Box>
    );
    return (
        <MidMarketRates />
    )
}
export default Header;
